import { gql } from "@apollo/client";

const CHECK_SHOWING_TIME_SCHEDULING_URL_EXPIRATION = gql`
  query checkShowingTimeSchedulingUrlExpiration($url: String!) {
    check_showing_time_scheduling_url_expiration(url: $url) {
      expired
    }
  }
`;

export default CHECK_SHOWING_TIME_SCHEDULING_URL_EXPIRATION;
